import { substring, isNullOrWhiteSpace } from "../fable_modules/fable-library.3.7.20/String.js";
import { tryFind, FSharpMap__get_IsEmpty } from "../fable_modules/fable-library.3.7.20/Map.js";
import { match, create } from "../fable_modules/fable-library.3.7.20/RegExp.js";

export function parseAndReplaceTemplate(startPosition, startTag, endTag, replacements, template) {
    if ((((isNullOrWhiteSpace(startTag) ? true : isNullOrWhiteSpace(endTag)) ? true : isNullOrWhiteSpace(template)) ? true : FSharpMap__get_IsEmpty(replacements)) ? true : (startPosition > (template.length - 1))) {
        return template;
    }
    else {
        const regex = create((startTag + "(.*?)") + endTag);
        const replace = (input) => {
            const regexMatch = match(regex, input);
            if (regexMatch != null) {
                const key = regexMatch[1] || "";
                const value = tryFind(key, replacements);
                const before = substring(input, 0, regexMatch.index);
                const after = substring(input, regexMatch.index + regexMatch[0].length);
                if (value == null) {
                    return (before + ((startTag + key) + endTag)) + replace(after);
                }
                else {
                    return (before + value) + replace(after);
                }
            }
            else {
                return input;
            }
        };
        return substring(template, 0, startPosition) + replace(substring(template, startPosition));
    }
}

